export enum ThemeName {
  aurora = 'aurora',
  moonlight = 'moonlight',
  seafoam = 'seafoam',
  blossom = 'blossom',
}

export interface ThemeObject {
  name: ThemeName;
}

export type Themes = {
  [key in ThemeName]: ThemeObject;
};

export const themes: Themes = {
  [ThemeName.aurora]: {
    name: ThemeName.aurora,
  },
  [ThemeName.blossom]: {
    name: ThemeName.blossom,
  },
  [ThemeName.moonlight]: {
    name: ThemeName.moonlight,
  },
  [ThemeName.seafoam]: {
    name: ThemeName.seafoam,
  },
};
